import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional Theme applied to the Data Grid
import { useRef } from "react";
import { useMouseTrap } from "../../utils";
import { debounce } from "lodash";

function DataTable({
  data,
  columns,
  onGridReady,
  rowCountColumn = columns[0]?.id,
  showSummary,
  getSummary,
  ...rest
}) {
  if (!rowCountColumn && columns[0]) {
    rowCountColumn = columns[0].id || columns[0].field;
  }
  const containerRef = useRef();
  const gridApiRef = useRef();
  const selectedNodesRef = useRef([]);
  useMouseTrap(containerRef, {
    "ctrl+a": (e) => {
      e.preventDefault();
      const filteredNodes = [];
      gridApiRef.current.forEachNodeAfterFilter((node) => {
        filteredNodes.push(node);
      });
      const selectedFilteredNodes = filteredNodes.filter(
        (node) => node.selected
      );
      if (selectedFilteredNodes.length) {
        selectedFilteredNodes.forEach((node) => node.setSelected(false));
      } else {
        filteredNodes.forEach((node) => node.setSelected(true));
      }
    },
  });
  const handleOnSelectionChanged = debounce((e) => {
    selectedNodesRef.current = gridApiRef.current.getSelectedNodes();
    updateSummary();
  }, 50);

  const updateSummary = debounce(() => {
    // let filteredRowsCount = 0;
    // gridApiRef.current.forEachNodeAfterFilter(() => filteredRowsCount++);
    // filteredRowsCountRef.current = filteredRowsCount;
    // selectedRowsCountRef.length = gridApiRef.current.getSelectedNodes().length;
    if (gridApiRef.current && showSummary && getSummary) {
      const selectedRows = gridApiRef.current
        .getSelectedNodes()
        .map((obj) => obj.data);
      const filteredRows = [];
      gridApiRef.current.forEachNodeAfterFilter((node) =>
        filteredRows.push(node.data)
      );

      const filteredRowsSummary = getSummary(filteredRows);
      const pinnedBottomRows = [filteredRowsSummary];
      if (selectedRows.length) {
        const selectedRowsSummary = getSummary(selectedRows);
        pinnedBottomRows.unshift(selectedRowsSummary);
      }

      if (rowCountColumn) {
        pinnedBottomRows.forEach((obj, i) => {
          if (pinnedBottomRows.length == 1 || i == 1) {
            obj[rowCountColumn] = `Total rows (${filteredRows.length})`;
          } else {
            obj[rowCountColumn] = `Selected rows (${selectedRows.length})`;
          }
        });
      }
      gridApiRef.current.setGridOption("pinnedBottomRowData", pinnedBottomRows);
    }
  }, 50);
  return (
    <div
      ref={containerRef}
      className="ag-theme-quartz"
      style={{ width: "100%", height: "100%" }}
    >
      <AgGridReact
        rowData={data}
        columnDefs={columns}
        rowSelection={{ mode: "multiRow", selectAll: "filtered" }}
        onGridReady={(e) => {
          gridApiRef.current = e.api;
          onGridReady?.(e);
        }}
        enableBrowserTooltips={true}
        enableCellTextSelection={true}
        onSelectionChanged={handleOnSelectionChanged}
        onRowDataUpdated={() => {
          selectedNodesRef.current?.forEach((node) =>
            gridApiRef.current.getRowNode(node.id)?.setSelected(true)
          );
          updateSummary();
        }}
        onFirstDataRendered={() => {
          updateSummary();
        }}
        onFilterModified={() => {
          updateSummary();
        }}
        {...rest}
      />
    </div>
  );
}

export default DataTable;
